import React, { useState } from "react";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import axios from "axios";
import { getURLbyEndPointV2 } from "../../../../../store/api";

const PARTY_TYPES = [
    "Exporter",
    "Importer",
    "Shipping line",
    "Indenting agent",
    "Freight Forwarders",
    "Custom Broker",
    "Port Authorities",
    "Logistics",
    "Transporter",
    "Bank",
    "Insurance Companies",
    "Other"
];

const AddPartyForm = ({ show, onHide, onSave, disputeId, role }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        partyType: "",
        firstName: "",
        lastName: "",
        companyName: "",
        country: "",
        email: "",
        phone: "",
        website: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        formData.role = role; 

        try {
            const response = await axios.post(
                getURLbyEndPointV2("addBindingParty") + disputeId,
                formData
            );

            if (response.data.status) {
                onSave(response.data.party);
                onHide();
                // Reset form
                setFormData({
                    partyType: "",
                    firstName: "",
                    lastName: "",
                    companyName: "",
                    country: "",
                    email: "",
                    phone: "",
                    website: ""
                });
            } else {
                setError(response.data.message || "Failed to add party");
            }
        } catch (error) {
            console.error("Error saving party:", error);
            setError(error.response?.data?.message || "Failed to add party");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Add Party</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label className="fs-6">Party Type</Form.Label>
                        <Form.Select
                            name="partyType"
                            value={formData.partyType}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select Party Type</option>
                            {PARTY_TYPES.map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">Company Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">Country</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="country"
                                    value={formData.country}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">Phone</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="phone"
                                    maxLength={15}
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fs-6">Website</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="website"
                                    value={formData.website}
                                    onChange={handleInputChange}
                                    placeholder="www.example.com"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" className="me-2" onClick={onHide} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading ? "Saving..." : "Save Party"}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddPartyForm;